import { useRecoilState } from "recoil";
import { recoilStates } from "src/recoil/recoilStates";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import GuideSlideBox from "../Swiper/GuideSlideBox";
import noGroup1 from "../../assets/images/noGroup1.png";
import noGroup2 from "../../assets/images/noGroup2.png";
import noGroup3 from "../../assets/images/noGroup3.png";
import noGroup4 from "../../assets/images/noGroup4.png";
import Button from "../Button";

export default function NoYearGroupContent() {
  const [group] = useRecoilState(recoilStates.group);
  const hasGroup = Boolean(group.id);

  const navigate = useNavigate();
  return (
    <Container className="d-flex fd-c gap-2 flex-1">
      <div className="flex-1 d-flex fd-c jc-sb gap-5 ">
        <GuideSlideBox
          initialSlideNum={0}
          goNextOnceAndStop={true}
          slideContents={[
            <img src={noGroup1} alt="" />,
            <img src={noGroup2} alt="" />,
            <img src={noGroup3} alt="" />,
            <img src={noGroup4} alt="" />,
          ]}
        />
      </div>
      <div className="button-container">
        <Button
          style={{ fontSize: "16px", border: "1px solid #1A1A1A" }}
          $colorTheme="white"
          $round={true}
          $buttonSize="md"
          onClick={() => {
            navigate("/year-booking/group-join");
            // navigate("/year-booking/group-register")
          }}
        >
          초대 코드 참여
        </Button>

        <Button
          style={{ fontSize: "16px" }}
          $colorTheme="green"
          $round={true}
          $buttonSize="md"
          onClick={() => navigate("/year-booking/group-register")}
          // onClick={() => navigate("/event-booking")}
        >
          연단체 신청하기
        </Button>
      </div>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  padding-bottom: 100px;

  .button-container {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 800px;
    padding: 8px 16px 26px 16px;
    background: linear-gradient(
      0deg,
      #fdfdfd 0%,
      #fdfdfd 60%,
      rgba(253, 253, 253, 0.3) 85%,
      rgba(253, 253, 253, 0) 100%
    );
    backdrop-filter: blur(10px);
    z-index: 1000;
    display: flex;
    gap: 8px;

    > button {
      flex: 1;
    }
  }

  /* Image Slider */
  .image-slider {
    width: 390px;
    height: 360px;
    position: absolute;
    left: 15px;
    overflow: hidden;
  }
`;

// "success": true,
// "data": {
//   "MSG": "예약에 성공 하였습니다.",
//   "BOOK_NO": "4403389",
//   "RESULT": "SUCCESS"
// }
